import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Lock, Check } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { errMsg, startCheckout } from "@/lib/api";

const FEATURES = ["Log unlimited mileage trips", "Record expenses and upload receipts", "Full Tax Report with mileage rates by trip date", "Download the Tax Summary PDF and CSV exports"];

export const UpgradeContent = ({ testId = "upgrade-panel" }) => {
  const [loading, setLoading] = useState(false);
  const go = async () => {
    setLoading(true);
    try {
      await startCheckout();
    } catch (e) {
      toast.error(errMsg(e));
      setLoading(false);
    }
  };
  return (
    <div data-testid={testId}>
      <div className="rounded-xl bg-emerald-950 text-white p-5">
        <p className="mt-overline !text-emerald-300">MileageTax Monthly</p>
        <p className="mt-2"><span className="font-mono text-4xl font-bold" data-testid={`${testId}-price`}>$9.99</span><span className="text-emerald-100/80">/month</span></p>
      </div>
      <ul className="mt-5 space-y-2.5">
        {FEATURES.map((f) => (
          <li key={f} className="flex items-start gap-2.5 text-slate-700">
            <Check className="w-5 h-5 text-emerald-600 shrink-0" />{f}
          </li>
        ))}
      </ul>
      <button type="button" onClick={go} disabled={loading} className="mt-btn-primary w-full mt-6" data-testid={`${testId}-subscribe-button`}>
        {loading && <Loader2 className="w-5 h-5 animate-spin" />}
        Subscribe for $9.99/month
      </button>
      <p className="text-xs text-slate-500 mt-3 text-center">Secure checkout by Stripe. Your account, dashboard and settings stay free.</p>
    </div>
  );
};

export const UpgradeDialog = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md rounded-2xl" data-testid="upgrade-dialog">
      <DialogHeader>
        <span className="w-12 h-12 rounded-2xl bg-emerald-50 flex items-center justify-center mb-2">
          <Lock className="w-6 h-6 text-emerald-700" />
        </span>
        <DialogTitle className="font-heading text-2xl font-bold">Upgrade to use this feature</DialogTitle>
        <DialogDescription>Adding trips and expenses, the Tax Report and the Tax Summary PDF are part of MileageTax Monthly.</DialogDescription>
      </DialogHeader>
      <UpgradeContent testId="upgrade-dialog-content" />
    </DialogContent>
  </Dialog>
);
